const londonDate = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/London',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

/** Match the server's London calendar cutoff without depending on the browser timezone. */
export const getBalanceToday = (now = new Date()) => {
  const parts = londonDate.formatToParts(now)
  const year = parts.find((part) => part.type === 'year')!.value
  const month = parts.find((part) => part.type === 'month')!.value
  const day = parts.find((part) => part.type === 'day')!.value

  return `${year}-${month}-${day}`
}

/** Compare canonical YYYY-MM-DD values; server validation remains authoritative. */
export const isFutureBalanceDate = (valueDate: string, now = new Date()) => valueDate > getBalanceToday(now)
